<template>
<div></div>
</template>
<script>
import { mapGetters } from "vuex";
import appDrawerItems from "@/data/app-drawer-items";
import { camel } from "@/utils/helpers";

export default {
  data() {
    return {
      flows: [{ name: "Untitled1", edit: false, id: 0 }],
      items: appDrawerItems,
      dark: false,
      logo: "/static/doocti.png",
      doologo: "/static/doologo.png",
    };
  },
  mounted() {
    const route = this.$route.name;
    if (route === "CallFlow/Render") {
      this.flows[0].name =  JSON.parse(localStorage.getItem('updateJSON')).name;
      // alert(this.flows[0].name);
    }
    this.$emit("changeFlow", [this.flows, this.flows[0]]);
    if (route === "CallFlow/Create") {
      this.showIcon = true;
    }
    const ps = document.getElementById("app-drawer");
    ps.addEventListener("mouseenter", this.miniEnterVariantHandler);
    ps.addEventListener("mouseleave", this.miniLeaveVariantHandler);
  },
  beforeDestroy() {
    const ps = document.getElementById("app-drawer");
    if (ps) {
      ps.removeEventListener("mouseenter", this.miniEnterVariantHandler);
      ps.removeEventListener("mouseleave", this.miniVariantHandler);
    }
  },
  computed: {
    ...mapGetters({
      clipped: "navClipped",
      navDrawer: "navDrawer",
      navMiniVarient: "navMiniVarient",
      navDrawerPosition: "navDrawerPosition",
      navDrawerScheme: "navDrawerScheme",
      navDrawerAlphaMod: "navDrawerAlphaMod",
      navDrawerAlphaImg: "navDrawerAlphaImg",
      navDrawerVariant: "navDrawerVariant",
      fixedFooter: "fixedFooter",
      showFooter: "showFooter",
      miniview: "miniview",
      UserPermissions: "UserPermissions",
    }),
    getlogo() {
      if (
        this.miniview &&
        this.navMiniVarient === true &&
        this.$vuetify.breakpoint.mdAndDown === false
      ) {
        return this.doologo;
      } else {
        return this.logo;
      }
    },
    activemenu() {
      return this.$vuetify.theme.activemenu;
    },
    drawer: {
      get() {
        return this.navDrawer;
      },
      set(value) {
        this.$store.dispatch("toggleDrawer", value);
      },
    },
    drawerItems() {
      let scope = this;
      if (!scope.UserPermissions) {
        return [];
      }
      let i = appDrawerItems
        .map((parent) => {
          if (parent.group) {
            parent.items = parent.items
              .map((child) => {
                if (child.auth === true) {
                  let filtered = scope.UserPermissions.filter((permission) => {
                    return child.permission.indexOf(permission) !== -1;
                  });
                  if (filtered.length > 0) {
                    child.show = true;
                    return child;
                  } else {
                    child.show = false;
                    return child;
                  }
                } else {
                  child.show = true;
                  return child;
                }
              })
              .filter((child) => {
                return child.show;
              });
            return parent;
          } else {
            let filtered = scope.UserPermissions.filter((permission) => {
              return parent.permission.indexOf(permission) !== -1;
            });
            if (filtered.length > 0) {
              parent.show = true;
              return parent;
            } else {
              parent.show = false;
              return parent;
            }
          }
        })
        .filter((parent) => {
          if (parent.group) {
            return parent.items.length > 0;
          } else {
            return parent.show;
          }
        });
      return i;
    },
  },
  methods: {
    miniEnterVariantHandler() {
      // if it's tab or small devive then it won't listen this event
      if (
        this.miniview &&
        this.navMiniVarient === true &&
        this.$vuetify.breakpoint.mdAndDown === false
      ) {
        this.$store.dispatch("toggleMiniVarient", false);
        // const container = document.querySelector('#app-sidebar')
        // container.scrollTop = 0
      }
    },
    miniLeaveVariantHandler() {
      // if it's tab or small devive then it won't listen this event
      if (
        this.miniview &&
        this.navMiniVarient === false &&
        this.$vuetify.breakpoint.mdAndDown === false
      ) {
        this.$store.dispatch("toggleMiniVarient", true);
      }
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (item.component) {
        return {
          name: item.component,
          params: {
            section: item.group,
            component: subItem.name,
          },
        };
      }
      return { name: `${item.group}/${camel(subItem.name)}` };
    },
  },
};
</script>
<style scoped lang="stylus">
// .no-overflow
// overflow: hidden
#app-drawer {
    img.logo {
        margin: 40px 0 15px;
    }

    .chip--x-small {
        font-size: 10px;
        height: 16px;

        .chip__content {
            line-height: 1;
            padding: 8px;
        }
    }

    .diamond-sponsor {
        // todo trim down actual image file dimensions
        height: 35px;
        margin-bottom: 0.25em;

        aside.navigation-drawer ul li {
            font-size: 14px;
            color: #373737;
        }

        &-label {
            color: #676767;
            margin: 24px 0 16px 0;
            font-size: 13px;
        }
    }
}

.white-bg,
.image,
.image>div {
    background-color: white !important;
}

.white-bg.v-toolbar__content {
    background-color: white !important;
}

.v-list__tile.theme--light {
    background: #fff;
}
</style>
